"use strict";
import React from "react";
import classNames from "classnames";
import DisablingButton from "../disabling_button";
export default React.createClass({
  resolveException: function() {
    this.props.recentlyResolved(this.props.exception);
    var self = this;
    var exception = self.props.exception;
    self.setState({ saving: true });
    self.props.exceptionResolver(exception, self.props.owner).then(function() {
      if (self.isMounted()) {
        self.setState({ saving: false });
      }
    });
  },
  getInitialState: function() {
    return {};
  },
  render: function() {
    var exception = this.props.exception;
    var itemClasses = classNames({
      rules__item: true
    });
    var exceptionClasses = classNames({
      rules__item: true,
      rules__ignored: exception.resolved_at
    });
    return /* @__PURE__ */ React.createElement("li", { className: itemClasses }, /* @__PURE__ */ React.createElement("span", { className: exceptionClasses }, /* @__PURE__ */ React.createElement("span", { className: "text" }, exception.message_override)), this.resolveButton(exception));
  },
  resolveButton: function() {
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.saving,
        disabledText: "Saving...",
        className: "rules__save-resolution-button",
        onClick: this.resolveException
      },
      "Remove This Exception"
    );
  }
});
